import { FlowchartGridRules } from './../interfaces/project';
import { ProjectFlowchartState } from './../shared/redux/project-flowchart.store';
import { ReduxService } from './redux.service';
import { SapiService } from './sapi.service';
import { Mediaclip } from './../interfaces/mediaclip';
import { FlowchartLink } from './../shared/models/flowchart-link.model';
import { Subject, Subscription } from 'rxjs';
import { FlowchartStep } from './../shared/models/flowchart-step.model';
import { Injectable, OnInit } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';

@Injectable()
export class FlowchartService implements OnInit {
	selection: any = { items: {} };
	selectionSubject: Subject<any>;
	private subscriptions: Subscription = new Subscription();

	constructor(
		protected localStorageService: LocalStorageService,
		protected reduxService: ReduxService,
		protected sapiService: SapiService) {
		this.selectionSubject = new Subject();
	}

	ngOnInit() {
		this.subscriptions.add(this.reduxService.stateObs.subscribe((state: ProjectFlowchartState) => {
			// console.warn('state from stateObs', state);
			// console.warn('state from stateObs', JSON.stringify(state));
			if (state && state.data && state.data.steps && this.selection && this.selection.count) {
				Object.keys(this.selection.items).forEach((itemId: string) => {
					const newStep = state.data.steps[itemId];
					if (newStep) {
						this.selection.items[itemId] = { ...newStep };
					}
				});
				this._updateSelection(this.selection.items);
			}
		}));
	}

	exit() {
		this.subscriptions.unsubscribe();
	}

	getGridRules(statsMode: boolean): FlowchartGridRules {
		return statsMode ? {
			x: {
				start: 150,
				track: 200,
				gutter: 300
			},
			y: {
				start: 100,
				track: 55,
				gutter: 10
			}
		} : {
			x: {
				start: 100,
				track: 135,
				gutter: 200
			},
			y: {
				start: 100,
				track: 20,
				gutter: 0
			}
		};
	}

	setSelection(selectionItems: any) {
		selectionItems = { ...selectionItems };
		this._updateSelection(selectionItems);
	}

	selectSingle(item: FlowchartStep | FlowchartLink) {
		const selectionItems = {};
		if (item && item.id) {
			selectionItems[item.id] = { ...item };
		}
		this._updateSelection(selectionItems);
	}

	clearSelection() {
		const selectionItems = {};
		this._updateSelection(selectionItems);
	}

	addToSelection(item: FlowchartStep | FlowchartLink) {
		const selectionItems = { ...this.selection.items };
		selectionItems[item.id] = { ...item };

		this._updateSelection(selectionItems);
	}

	removeFromSelection(item: FlowchartStep | FlowchartLink) {
		const selectionItems = { ...this.selection.items };
		delete selectionItems[item.id];
		this._updateSelection(selectionItems);
	}

	toggleSelection(item: FlowchartStep | FlowchartLink) {
		const selectionItems = { ...this.selection.items };
		if (selectionItems[item.id]) {
			delete selectionItems[item.id];
		} else {
			selectionItems[item.id] = { ...item };
		}
		this._updateSelection(selectionItems);
	}

	updateItems(items: any) {
		this._updateSelection(items);
	}

	undo() {
		this.reduxService.dispatch({ type: 'UNDO' });
	}

	redo() {
		this.reduxService.dispatch({ type: 'REDO' });
	}

	private _updateSelection(selectionItems: any) {
		// console.warn('_updateSelection selectionItems', selectionItems)
		if (this.selection.single) {
			this.selection.lastSelected = { ...this.selection.single };
		}

		this.selection.items = { ...selectionItems };
		const itemKeys = Object.keys(selectionItems);
		this.selection.count = itemKeys.length;
		if (this.selection.count === 1) {
			this.selection.single = { ...this.selection.items[itemKeys[0]] };
			const selected = this.selection.single;
			if (selected && selected.entityId && selected.entityType === 'mediaclip') {
				this.sapiService.get(selected.entityType, selected.entityId).subscribe((item: Mediaclip) => {
					if (item && item.id) {
						this.selection.entity = { ...item };
						this.selectionSubject.next(this.selection);
					}
				});
			} else {
				this.selection.entity = null;
			}
		} else {
			this.selection.entity = null;
			this.selection.single = null;
		}

		this.selectionSubject.next(this.selection);
	}
}
